import { render, staticRenderFns } from "./LazyCategoryProducts/template.pug?vue&type=template&id=6ed7d33d&lang=pug&"
import script from "./LazyProductList.vue?vue&type=script&lang=js&"
export * from "./LazyProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports